export function getDays(hours) {
  return {
    days: Math.floor(hours / 24),
    hours: hours % 24
  }
}
